var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"markers"},_vm._l((_vm.stepStatuses),function(stepStatus){return _c('div',{key:stepStatus.key,class:_vm.getClass(stepStatus.active, stepStatus.status)})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }